export default {
  back: 'Mehr',
  loading: 'Lädt …',
  loadError: 'Konnte nicht laden: {error}',
  title: 'Health',
  titleDesktop: 'Dein Körper, jeden Tag',
  kicker: '{days} Tage aufgezeichnet · seit {date}',
  range: 'Zeitraum',
  ranges: { d30: '30 T', d90: '90 T', y1: '1 J', all: 'Alles' },
  empty: 'Noch keine Health-Daten. Nach dem ersten Garmin-Sync erscheinen sie hier.',
  tiles: 'Kennzahlen',
  ofN: '{a} von {b}',
  goalReached: 'Ziel erreicht',
  below: 'darunter',
  trainingDay: 'Trainingstag',
  avg7: '7-Tage-Mittel',
  hrv: {
    band: 'Normalband',
    night: 'Nachtwert',
    title: 'HRV über Nacht',
    sub: 'Garmin-Normalband als Fläche · letzte {count} Nächte',
    lastNight: 'letzte Nacht · {text}',
    chartLabel: 'HRV der letzten {span} Nächte mit Normalband; {below} Nächte unter dem Band',
    empty: 'Keine HRV-Werte im Zeitraum.',
    span: 'HRV-Zeitraum',
    belowBand: ' Nächten unter dem Band.',
    noValues: 'Ohne Werte keine Aussage.',
  },
  rhr: {
    day: 'Tageswert',
    same: 'unverändert',
    higher: '{n} bpm höher',
    lower: '{n} bpm niedriger',
    title: 'Ruhepuls',
    sub: 'niedrigster Wert des Tages · Garmin',
    last: 'zuletzt',
    chartLabel: 'Ruhepuls im Zeitraum, zuletzt {value} Schläge pro Minute',
    empty: 'Kein Ruhepuls im Zeitraum.',
    takeaway: 'Letzte Woche gegen erste Woche im Zeitraum: ',
  },
  sleep: {
    deep: 'Tief',
    light: 'Leicht',
    rem: 'REM',
    awake: 'Wach',
    goalLine: 'Ziel 7:30',
    title: 'Schlaf, letzte {count} Nächte',
    sub: 'Phasen gestapelt · Ziel 7:30 h',
    gaps: ' · Lücken = Uhr nicht getragen',
    overNights: 'über {count} Nächte',
    chartLabel: 'Gestapelte Schlafphasen der letzten {nights} Nächte, Schnitt {mean} Stunden',
    empty: 'Keine Schlafdaten im Zeitraum.',
    goalLegend: 'Ziel 7:30 h',
    reachedIn: 'Ziel erreicht in ',
    nights: ' Nächten.',
  },
  bb: {
    range: '{min} bis {max}',
    span: 'Spanne',
    title: 'Body Battery',
    sub: 'Spanne je Tag vom Tief- bis zum Höchstwert',
    chartLabel: 'Body Battery je Tag als Spanne, Höchstwert im Schnitt {mean}',
    empty: 'Keine Body-Battery-Werte.',
    noTraining: 'ohne Training',
    takeaway: 'Morgens geladen auf ',
  },
  stress: {
    levels: { rest: 'Ruhe', low: 'niedrig', medium: 'mittel', high: 'hoch' },
    avg: 'Ø Stress',
    title: 'Stress je Tag',
    sub: 'Tagesmittel 0–100 · Garmin',
    chartLabel: 'Stress je Tag, im Schnitt {mean}',
    empty: 'Keine Stresswerte.',
    over50: '; an {high} von {count} Tagen über 50.',
  },
  steps: {
    thousand: '{n} T',
    name: 'Schritte',
    goal: 'Ziel {n}',
    title: 'Schritte',
    sub: 'je Tag · dunkel = Ziel erreicht',
    perDay: 'pro Tag',
    chartLabel: 'Schritte je Tag, Ziel an {reached} von {count} Tagen erreicht',
    empty: 'Keine Schritte im Zeitraum.',
    reachedOn: 'Ziel erreicht an ',
    days: ' Tagen.',
  },
  intensity: {
    name: 'Intensitätsminuten',
    goal: 'Ziel {n}',
    title: 'Intensitätsminuten je Woche',
    sub: 'Woche ab Montag · Ziel {n} min (WHO)',
    chartLabel: 'Intensitätsminuten je Woche, Ziel in {reached} von {count} vollen Wochen erreicht',
    empty: 'Keine Intensitätsminuten.',
    reachedIn: 'Ziel erreicht in ',
    weeks: ' vollen Wochen.',
  },
  weight: {
    name: 'Gewicht',
    summary: 'Gewicht · letzte 12 Monate',
    hide: 'ausblenden',
    show: 'anzeigen',
    chartLabel: 'Gewichtsverlauf mit {count} Messungen',
    count: '{count} Messungen',
    change: ' · {value} kg im Zeitraum',
    empty: 'Keine Messungen in den letzten 12 Monaten.',
  },
  spo2: {
    sub: 'Sauerstoffsättigung',
    subDays: { one: 'Sauerstoffsättigung · {count} Tag mit Messung in 12 Monaten', other: 'Sauerstoffsättigung · {count} Tage mit Messung in 12 Monaten' },
    lowest: ' · tiefster Wert {value} am {date}',
    none: 'Keine Messung in den letzten 12 Monaten. Die Uhr misst SpO2 nur, wenn der Pulsoximeter eingeschaltet ist.',
  },
};
